<template>
  <div>
    <v-row
      align="start"
      dense
      justify="space-between"
    >
      <v-col cols="8">
        <v-list-item
          dense
        >
          <v-list-item-content>
            <div
              class="name"
              v-text="cartItem.name"
            />
            <display-if-catalog-has-physical-items>
              <div
                v-if="cartItem.fulfillmentType"
                class="fulfillment-type"
                v-text="
                  $itemFulfillmentMixin_fulfillmentTypeLabelMap[
                    cartItem.fulfillmentType
                  ]
                "
              />
            </display-if-catalog-has-physical-items>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col
        class="mt-1"
        cols="auto"
      >
        <div
          class="mr-3 text-right font-weight-bold formattedAmount text-no-wrap"
          v-text="formatAmount"
        />
        <div
          v-if="itemHasFee"
          class="cartFee"
        >
          <div
            class="mr-3 text-right mt-1 formattedFee text-no-wrap"
            v-text="formatFee(cartItem)"
          />
        </div>
      </v-col>
    </v-row>
    <v-btn
      small
      class="cart-edit-btn ml-1"
      color="primary"
      text
      @click="editItem"
      @keyup.enter.prevent="editItem"
    >
      {{ $t('catalog-cart-edit-button') }}
    </v-btn>
    <v-btn
      small
      class="cart-remove-btn"
      color="primary"
      text
      @click="removeItem"
      @keyup.enter.prevent="removeItem"
    >
      {{ $t('catalog-cart-remove-button') }}
    </v-btn>
    <v-divider class="mb-2 mt-3 mx-3" />
  </div>
</template>
<script>
import { ItemFeeMixin } from '@/components/shared/mixins/item-fee-mixin'
import CartItem from '@/store/classes/cart-item'
import { ItemFulfillmentMixin } from '@/components/shared/mixins/item-fulfillment-mixin'
import DisplayIfCatalogHasPhysicalItems from '@/components/shared/catalog/DisplayIfCatalogHasPhysicalItems'

export default {
  name: 'CartMenuItem',
  components: {
    DisplayIfCatalogHasPhysicalItems
  },
  mixins: [ItemFeeMixin, ItemFulfillmentMixin],
  props: {
    cartItem: {
      type: [CartItem, Object],
      required: true
    }
  },
  computed: {
    formatAmount () {
      return this.$money(
        this.cartItem.selectedAmount,
        this.cartItem.currencyCode
      )
    },
    itemHasFee () {
      return this.cartItem.fee && this.cartItem.fee.cost > 0
    }
  },
  methods: {
    removeItem () {
      this.$emit('remove-cart-item', this.cartItem)
    },
    editItem () {
      this.$emit('edit-cart-item', this.cartItem)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/variables';

  .fulfillment-type {
    color: $tangoTextPrimary !important;
    font-size: 0.875rem !important;
  }
  .name  {
    font-weight: 700 !important;
    margin-bottom: 8px !important;
    font-size: 1rem !important;
    white-space: break-spaces !important;
    word-break: break-word !important;
  }
</style>
